// extracted by mini-css-extract-plugin
export var alertIcon = "_q4-0";